module.exports = __webpack_public_path__ + "vfn-assets/img/individual-upgrade-membresía.41e8e68b.png";